import { FC } from 'react';
import EmailIcon from '../../assets/images/email.png';
import useResendEmailConfirmation from '../../hooks/auth/useResendEmailConfirmation';
import LoadingIndicator from '../Common/LoadingIndicator';
import Notify from '../Common/Notify';

type Props = {
  email: string;
};
export const ConfirmEmail: FC<Props> = ({ email }) => {
  const { onClickHandler, submitting, success, error } = useResendEmailConfirmation();
  return (
    <div className='text-center col-lg-8 offset-lg-2 mt-10'>
      <img src={EmailIcon} alt='Email Notification' width='100px' />
      <h3>Email Confirmation</h3>
      We have sent an email to <span className='text-primary fw-bold'>{email}</span> to confirm the validity of your email email address. After receiving the email, follow the link provided to complete your sign up process
      <div className='mt-8 mb-5'>
        If you did not get an email
        <br />
        <button className='btn btn-bg-light me-2 text-primary mt-2 fs-7' onClick={() => onClickHandler(email)}>
          {submitting ? <LoadingIndicator /> : 'Resend Confirmation Email'}{' '}
        </button>
      </div>
      {error && <Notify message={error} type='danger' />}
      {success && <Notify message='Email confirmation link resent.' type='success' />}
    </div>
  );
};
